import { Api } from "../config/request";

export default {
  postImage(body) {
    return Api.post("/communication_hub/upload_image", body);
  },
  postVideo(body) {
    return Api.post("/communication_hub/upload_video", body);
  },
  deleteAssignment(body) {
    return Api.post("/communication_hub/assign/delete", body);
  },
  getList(body) {
    return Api.post("/communication_hub/list", body);
  },
  getDetail(params) {
    return Api.get(
      `/communication_hub/detail?element_type=${params.element_type}&element_id=${params.element_id}`
    );
  },
  getBulkUploadUrl(payload) {
    return Api.post(`/communication_hub/bulk_assign`, payload);
  },
  assign(body) {
    return Api.post("/communication_hub/assign", body);
  },
  getAssignHistory(body) {
    return Api.post("/communication_hub/assign/list", body);
  },
  createElement(body) {
    return Api.post("/communication_hub/upsert", {
      ...body,
      request_type: "CREATE",
    });
  },
  updateElement(body) {
    return Api.post("/communication_hub/upsert", {
      ...body,
      request_type: "UPDATE",
    });
  },

  getOptions() {
    return Api.get("/communication_hub/options");
  },

  forceComplete(body) {
    return Api.post("/communication_hub/force_complete", body);
  }
};
